import { Globe } from 'lucide-react';
import { useTranslation } from '@/i18n/LanguageContext';
import { languageNames, languageFlags, type Language } from '@/i18n/translations';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const languages: Language[] = ['sv', 'en', 'no', 'da', 'de', 'fr'];

export function LanguageSelector({ className }: { className?: string }) {
  const { language, setLanguage } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className={className} aria-label="Select language" data-testid="language-selector">
          <Globe className="w-4 h-4 mr-1" aria-hidden="true" />
          <span className="text-sm" aria-label={languageNames[language]}>{languageFlags[language]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang}
            onClick={() => setLanguage(lang)}
            className={language === lang ? 'bg-accent/20 font-medium' : ''}
          >
            <span className="mr-2">{languageFlags[lang]}</span>
            {languageNames[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
